// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// eslint-disable-next-line spire/fenced-imports
import { FlipOptions, Placement, ShiftOptions } from "@floating-ui/dom";
import { FloatingTooltipProps } from "@keller/App/Components/FloatingTooltip/FloatingTooltip";

export const tooltipDefaultProps: Omit<FloatingTooltipProps, "triggerComponent" | "placement"> & {
    flip?: FlipOptions;
    shift?: ShiftOptions;
    placement: Placement;
    groupDelay: {
        open: number;
        close: number;
    };
} = {
    flip: {
        padding: 5,
    },
    shift: {
        padding: 5,
    },
    offset: 16,
    trigger: "hover",
    placement: "bottom",
    showArrow: true,
    isOpen: false,
    groupDelay: {
        open: 400,
        close: 500,
    },
};
